<div class="modal-heading">
  <div class="close-button invisible"></div>
  <div class="header-section">
    <span class="header-text"
      >Bank Statement Details ({{ data?.pincode ? data.pincode + ', ' : '' }}{{ data?.district }})
{{ bankDetails.length ? '[' + bankDetails.length + ']' : '' }}</span
    >
    @if (bankDetails.length) {
      <button type="button" class="dp-secondary-btn" style="height: 3.5vh;" (click)="exportData()">
        Export Excel
      </button>
    }
  </div>
  <div class="close-button" (click)="closeDialog()">
    <mat-icon class="close-icon">close</mat-icon>
  </div>
</div>

<div class="modal-body">
  <div style="margin-top: 20px"></div>
<div class="table-container">
    
    <table class="table">
     
        <thead class="table-head">
            <tr>

                <th>
                    <span>Txn. date</span>
                </th>
                <th>
                    <span>Txn. ID</span>
                </th>
                <th>
                    <span>Amount</span>
                </th>
                <th>
                    <span>Txn. details</span>
                </th>
                <th>
                    <span>Bank Name</span>
                </th>
                <th>
                    <span>IFSC Code</span>
                </th>
                <th>
                    <span>Branch</span>
                </th>
                <th>
                    <span>City</span>
                </th>
                <th>
                    <span>Pincode</span>
                </th>
                <th>
                    <span>Action</span>
                </th>
               
            </tr>
        </thead>
        
        <tbody class="table-body">
            @if(bankDetails.length > 0){
            @for(row of bankDetails; track row){
            <tr>
               
                <td data-label="Txn. Date">
                    {{row.txnDate}}
                </td >
                <td data-label="Txn. ID">
                    {{row.txnId}}
                </td>
                <td data-label="Amount">
                    {{row.txnAmount}}
                </td>
                <td data-label="Txn. details">
                    {{row.txnDesc}}
                </td>
                <td data-label="Bank Name">
                    {{row.txnBranch.bank_name}}
                </td>
                <td data-label="IFSC Code">
                    {{row.txnBranch.ifsc}}
                </td>
                <td data-label="Branch">
                    {{row.txnBranch.branch_name}}
                </td>
                <td data-label="City">
                    {{row.txnBranch.city}}
                </td>
                <td data-label="Pincode">
                    {{row.txnBranch.pincode}}
                </td>
                <td data-label="Action">
                    @if (row.traceDetails) {
                        <div class="d-flex gap-2 justify-content-center">
                            <img src="../../../assets/images/checkbox-circle-line-selected.svg" title="Uplod Complete" alt="close icon" class="tick-btn"/>
                            <img src="../../../assets/images/view.svg" title="View Details" alt="close icon" class="tick-btn" (click)="openViewTrace(row.traceDetails)" />
                        </div>
                    }@else {
                <img (click)="onClickDocx(row,$event)" src="../../../assets/images/sticky-note-add-line.svg" title="Uplod Sleeves" alt="view" class="Upload-doc-icon"/>
                    }
                </td>

            </tr>
        }
            
    
            }@else{
            <tr>
                <td colspan="5" style="text-align: center;">
                    No Records Found
                </td>
            </tr>
            }
           
        </tbody>
    </table>
</div>
</div>